import {AbstractControl, ValidatorFn} from '@angular/forms';
import * as moment from 'moment';

export function maxAgeRestriction(ageInMonths): ValidatorFn {
  const DATE_REGEX = new RegExp(/^(\d{2}|\d)\/(\d{2}|\d)\/\d{4}$/);

  return (control: AbstractControl): { [key: string]: any } => {
    let dateStr: any = control.value;

    if (dateStr && typeof dateStr !== 'string') {
      dateStr = dateStr.format('DD/MM/YYYY');
    }

    // First check for dd/mm/yyyy format
    // If pattern is wrong, don't validate yet
    if (!DATE_REGEX.test(dateStr)) {
      return null;
    }

    // Object to return if date is invalid
    const invalidObj = {'maxAge': true};

    let today = moment().format('DD/MM/YYYY');
    let birthdate = moment(dateStr, 'DD/MM/YYYY');
    let months = moment().diff(birthdate, 'months', true);

    if (months > ageInMonths) {
      return invalidObj;
    } else {
      return null;
    }
  };
}

export function minAgeRestriction(ageInMonths): ValidatorFn {
  const DATE_REGEX = new RegExp(/^(\d{2}|\d)\/(\d{2}|\d)\/\d{4}$/);

  return (control: AbstractControl): { [key: string]: any } => {
    let dateStr: any = control.value;

    if (dateStr && typeof dateStr !== 'string') {
      dateStr = dateStr.format('DD/MM/YYYY');
    }

    // First check for dd/mm/yyyy format
    // If pattern is wrong, don't validate yet
    if (!DATE_REGEX.test(dateStr)) {
      return null;
    }

    // Object to return if date is invalid
    const invalidObj = {'minAge': true};

    let birthdate = moment(dateStr, 'DD/MM/YYYY');
    let months = moment().diff(birthdate, 'months', true);

    if (months < ageInMonths) {
      return invalidObj;
    } else {
      return null;
    }
  };
}
